import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { HttpHeaders } from '@angular/common/http';

const urlPrefix = '/portal';

@Injectable({
  providedIn: 'root'
})
export class PortalBackendServer extends BaseBackend {

  sendAccessCode(ticketNo, secret) {
    return this.post(`${ urlPrefix }/${ ticketNo }/access-code`, { secret });
  }

  issueToken(ticketNo, secret, accessCode) {
    const body = { secret, accessCode };
    return this.post(`${ urlPrefix }/${ ticketNo }/token`, body);
  }

  portalTicket(ticketNo, token) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ token }`,
      // 'Company': Company.Sea
    });

    return this.get(`${ urlPrefix }/${ ticketNo }`, { headers });
  }

  cancelRequest(ticketNo, token) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ token }`,
      // 'Company': Company.Sea
    });

    return this.post(`${ urlPrefix }/${ ticketNo }/cancel`, null, { headers });
  }

  creditCardPayment(data, token) {
    const { ticketNo } = data;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ token }`,
      // 'Company': Company.Sea
    });

    return this.post(`${ urlPrefix }/${ ticketNo }/payment`, data, { headers });
  }
}
